import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {SelectFilterDataComponent} from "./select-filter-data.component";
import {SelectFilterModule} from "../../../../components/common/select-filter/select-filter.module";
import {ContentModule} from "../../../../shared/directives/content.module";
import {ErrorTextModule} from '../error-text/error-text.module';

@NgModule({
    declarations: [
        SelectFilterDataComponent,
    ],
    exports: [
        SelectFilterDataComponent,
        ContentModule,
    ],
    imports: [
        ReactiveFormsModule,
        CommonModule,
        SelectFilterModule,
        ErrorTextModule,
    ]
})
export class SelectFilterDataModule {
}
